module.exports = __webpack_public_path__ + "img/team-leks.aa14f84a.jpg";